export default [
  {
    path: '/app/admin/map',
    name: 'mapMarkerAdmin',
    components: {
      default: () => import('../../views/mapDevice/indexAdmin.vue')
    }
  },
  {
    path: '/app/admin/map/multipleView',
    name: 'multipleViewAdmin',
    components: {
      default: () => import('../../views/viewMulti/indexAdmin.vue')
    }
  },
  {
    path: '/app/admin/monitoring',
    name: 'MonitorViewAdmin',
    components: {
      default: () => import('../../views/monitor/indexMonitor.vue')
    }
  },
  {
    path: '/app/admin/ftp',
    name: 'ftpPagesAdmin',
    components: {
      default: () => import('../../views/ftp/indexFtpAdmin.vue')
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/mapAdmin.js